// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconHome1 = createRemixIcon('IconHome1', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12 .318l11.25 10.125V23.25H.75V10.443zM3.25 11.557v9.193h17.5v-9.193L12 3.682z\" clip-rule=\"evenodd\"/>");
